import { format, isToday, isYesterday } from "date-fns";
import { ptBR } from "date-fns/locale";

import {
  SUPPORT_STATUS_LABEL,
  SupportRequestHistory,
  SupportRequestStatusEnum,
} from "../entities/SupportRequest";
import { UserRoleEnum } from "../services/usersService/user";

export const allowedTransitions: Record<
  SupportRequestStatusEnum,
  SupportRequestStatusEnum[]
> = {
  [SupportRequestStatusEnum.OPEN]: [
    SupportRequestStatusEnum.IN_PROGRESS,
    SupportRequestStatusEnum.CANCELLED,
  ],
  [SupportRequestStatusEnum.IN_PROGRESS]: [
    SupportRequestStatusEnum.ESCALATED_TECHNICAL,
    SupportRequestStatusEnum.AWAITING_SELLER,
    SupportRequestStatusEnum.RESOLVED,
    SupportRequestStatusEnum.CANCELLED,
  ],
  [SupportRequestStatusEnum.ESCALATED_TECHNICAL]: [
    SupportRequestStatusEnum.IN_PROGRESS,
    SupportRequestStatusEnum.AWAITING_SELLER,
    SupportRequestStatusEnum.RESOLVED,
    SupportRequestStatusEnum.CANCELLED,
  ],
  [SupportRequestStatusEnum.AWAITING_SELLER]: [
    SupportRequestStatusEnum.IN_PROGRESS,
    SupportRequestStatusEnum.ESCALATED_TECHNICAL,
    SupportRequestStatusEnum.RESOLVED,
    SupportRequestStatusEnum.CANCELLED,
  ],
  [SupportRequestStatusEnum.RESOLVED]: [SupportRequestStatusEnum.CLOSED],
  [SupportRequestStatusEnum.CLOSED]: [],
  [SupportRequestStatusEnum.CANCELLED]: [],
};

export const allowedRolesSupportRequest: UserRoleEnum[] = [
  UserRoleEnum.ADMIN,
  UserRoleEnum.SUPER_ADMIN,
  UserRoleEnum.SUPPORT,
];

export const updateNotAllowed = [
  SupportRequestStatusEnum.CLOSED,
  SupportRequestStatusEnum.CANCELLED,
];

export const ownerAllowedStatus = [
  SupportRequestStatusEnum.RESOLVED,
  SupportRequestStatusEnum.CLOSED,
];

export const getStatusListOrder = (status: SupportRequestStatusEnum): number =>
  status === SupportRequestStatusEnum.IN_PROGRESS ? 0 : 1;

export const DEFAULT_STAFF_STATUS_FILTER: SupportRequestStatusEnum[] = [
  SupportRequestStatusEnum.IN_PROGRESS,
  SupportRequestStatusEnum.ESCALATED_TECHNICAL,
  SupportRequestStatusEnum.AWAITING_SELLER,
];

export const SUPPORT_MAX_ATTACHMENTS = 10;
export const SUPPORT_IMAGE_MAX_BYTES = 10 * 1024 * 1024;
export const SUPPORT_VIDEO_MAX_BYTES = 50 * 1024 * 1024;
export const SUPPORT_ALLOWED_IMAGE_MIMES = [
  "image/jpeg",
  "image/png",
  "image/webp",
];
export const SUPPORT_ALLOWED_VIDEO_MIMES = ["video/mp4", "video/quicktime"];

export const getHistoryEntryTitle = (entry: SupportRequestHistory): string => {
  const toLabel = entry.to
    ? (SUPPORT_STATUS_LABEL[entry.to] ?? entry.to)
    : null;
  const fromLabel = entry.from
    ? (SUPPORT_STATUS_LABEL[entry.from] ?? entry.from)
    : null;

  if (!toLabel) return "Atualização do chamado";

  return fromLabel ? `${fromLabel} → ${toLabel}` : toLabel;
};

export const formatHistoryDate = (date?: string): string => {
  if (!date) return "—";

  const parsedDate = new Date(date);
  const time = format(parsedDate, "HH:mm", { locale: ptBR });

  if (isToday(parsedDate)) return `hoje às ${time}`;
  if (isYesterday(parsedDate)) return `ontem às ${time}`;

  return `${format(parsedDate, "dd/MM/yyyy", { locale: ptBR })} às ${time}`;
};
